module.exports = __webpack_public_path__ + "img/pl35.7e97fa40.jpg";